import { Image } from '@/interfaces/GeneralInterfaces'

export enum TsUserRole {
  MANAGER = 'manager',
  RATER = 'rater',
  RATEE = 'ratee'
}

export interface TsAbstractUser {
  id: number
  fullName: string
  email: string
  role: string
}

export interface TsRateeUser {
  id: number
  fullName: string
  email: string
  image: Image | null
  isLive: boolean
  expiryTime: Date | null
}

export interface TsRaterUser {
  id: number
  fullName: string
  email: string
  image: Image | null
}

export interface TsManagerUser {
  id: number
  fullName: string
  email: string
  image: Image | null
}

export interface TsNewUserForm {
  email: string,
  firstName: string,
  lastName: string
}

export interface TsUserDto {
  roles: TsUserRole[],
  users: TsAbstractUser[]
}

export interface TsRaterRateeSkillRating {
  score: number
  comment: string
}

export interface TsRatingForm {
  score: number
  comment: string
}

export interface TsRateeReview {
  id: number,
  score: number
  timeCreated: string | null
  timeExpiry: string | null
}

export interface TsManagerRatingAvarageScore {
  score: number
}

export interface TsManagerRating {
  score: string
  comment: string
  timeCreated: string | null
}

export interface TsRateeRatingResults {
  performanceReviewScore: number
  leadershipSurveyScore: number,
  eqChartLabels: TsEqGridChartLabels | [],
  legends?: TsEqGridChartLegends[]
}

export interface TsRateeReportsFields {
  key: string,
  labelMobile?: string,
  label?: string,
  sortable?: boolean
}

export interface TsEqGridChartLabels {
  labelA1: string,
  labelA2: string,
  labelA3: string,
  labelB1: string,
  labelB2: string,
  labelB3: string,
  labelC1: string,
  labelC2: string,
  labelC3: string,
  labelXAxis?: string,
  labelYAxis?: string
}

export interface TsEqGridChartLegends {
  label: string,
  bgColor: string,
  borderColor: string
}
